import actions from './actions';

const {
  LIST_PRODUCTO,
  LIST_PRODUCTO_SELECTBOX,
  CREATE_PRODUCTO,
  READ_PRODUCTO,
  UPDATE_PRODUCTO,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},  
};


const productoCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_PRODUCTO:
      return {
        ...state,
        data: data
      }
    case LIST_PRODUCTO_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_PRODUCTO:
      return {
        ...state,
        record: data
      }
    case READ_PRODUCTO:
      return {
        ...state,
        record: data
      }
    case UPDATE_PRODUCTO:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default productoCrudReducer;
